import LazyImage from '../ui/LazyImage';
import { useLanguage } from '../../context/LanguageContext';

export default function GalleryGrid({ images, onImageClick }) {
  const { language } = useLanguage();

  return (
    <div className="gallery-grid">
      {images.map((image, index) => (
        <button
          key={image.id}
          onClick={() => onImageClick(index)}
          className="relative rounded-xl overflow-hidden group focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2"
        >
          <LazyImage
            src={image.src}
            alt={image.alt[language]}
            aspectRatio="4/3"
            className="w-full transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
            <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity font-medium">
              {image.alt[language]}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
}
